import { IOfferCard } from '../../../../types';
import { prepareAvatarLink } from './prepareAvatarLink';
import { prepareAvatarType } from './prepareAvatarType';

export const prepareAvatar = (offerCard: IOfferCard) => ({
  src: prepareAvatarLink(offerCard),
  type: prepareAvatarType(offerCard),
});
